export function 	initializeLightboxContainer() {
    const lightboxEmbed = document.querySelectorAll('.site-video-embed-group, .farlo-ui-lightbox__toggle, .wp-block-gallery');
    var count = 0;
    if (lightboxEmbed.length > 0 && count === 0) {
        const div = document.createElement('div');
        const divInner = document.createElement('div');
        const divInnerContent = document.createElement('div');
        const divClose = document.createElement('button');
        const divBackdrop = document.createElement('div');
        div.className = 'farlo-ui-lightbox';
        divInner.className = 'farlo-ui-lightbox__inner';
        divInnerContent.className = 'farlo-ui-lightbox__content-inner';
        divClose.className = 'farlo-ui-lightbox__close';
        divBackdrop.className = 'farlo-ui-lightbox__backdrop';
        
        // Append elements to create the lightbox container
        div.appendChild(divInner);
        divInner.appendChild(divInnerContent);
        divInner.appendChild(divClose);
        div.appendChild(divBackdrop); 
        document.body.appendChild(div);
        count = count + 1;
    }
}